import { useCallback, useMemo } from "react";

import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { canDeleteTemplate } from "shared/Templates/access/canDeleteTemplate";
import { Action, Template } from "types/generated";
import { checkAllowedAction } from "utils/access";

import { showCreateTemplateDrawer } from "../../CreateTemplateDrawer";
import { showDeleteConfirmation } from "../../DeleteConfirmation";

const TemplatesTableRowActionsCell = ({
  item: template,
  ...cellProps
}: TableSimpleCellProps<Template>) => {
  const canManageTemplate = checkAllowedAction(template, Action.UpdateBlueprintsVersionedGroup);
  const canDelete = canDeleteTemplate(template);

  const onEditDetails = useCallback(() => {
    showCreateTemplateDrawer({ id: template.id, template });
  }, [template]);
  const menuItems = useMemo(() => {
    const items = [];

    if (canManageTemplate.result || !!canManageTemplate.message) {
      items.push(
        <DropdownMenuItem
          key="edit"
          onAction={onEditDetails}
          isDisabled={!canManageTemplate.result}
          tooltip={canManageTemplate.message}
          tooltipPlacement="left"
        >
          Edit
        </DropdownMenuItem>
      );
    }

    if (canDelete.result || !!canDelete.message) {
      items.push(
        <DropdownMenuItem
          key="delete"
          onAction={() => showDeleteConfirmation({ name: template.name, id: template.id })}
          danger
          isDisabled={!canDelete.result}
          tooltip={canDelete.message}
          tooltipPlacement="left"
        >
          Delete
        </DropdownMenuItem>
      );
    }

    return items;
  }, [canManageTemplate, canDelete, template, onEditDetails]);

  return (
    <TableSimpleCell {...cellProps}>
      {menuItems.length > 0 && (
        <DropdownMenuEllipsis tooltip="Template actions">{menuItems}</DropdownMenuEllipsis>
      )}
    </TableSimpleCell>
  );
};

export default TemplatesTableRowActionsCell;
